import { Link } from 'react-router-dom'
import { useOptionalT } from '../i18n/LocaleProvider'
import { Btn } from './Btn'

export interface EventCardProps {
  image: string
  /** Day number, e.g. `29`. The source keeps a trailing space before the month. */
  day: string
  month: string
  title: string
  descr: string
  infoTitle: string
  infoDescr: string
  to: string
  ctaLabel?: string
  /** `inner` adds the `ul-event--inner` modifier used on the events listing. */
  variant?: 'default' | 'inner'
}

/** A `.ul-event` card, used by the `events` listing (4 cards). */
export function EventCard({
  image,
  day,
  month,
  title,
  descr,
  infoTitle,
  infoDescr,
  to,
  ctaLabel: ctaLabelProp,
  variant = 'default',
}: EventCardProps) {
  const t = useOptionalT()
  const ctaLabel = ctaLabelProp ?? t('ul.eventCard.cta')
  return (
    <div className={variant === 'inner' ? 'ul-event ul-event--inner' : 'ul-event'}>
      <div className="ul-event-img">
        <img src={image} alt="Event Image" />
        <span className="date">
          {day} <span>{month}</span>
        </span>
      </div>
      <div className="ul-event-txt">
        <h3 className="ul-event-title">
          <Link to={to}>{title}</Link>
        </h3>
        <p className="ul-event-descr">{descr}</p>
        <div className="ul-event-info">
          <span className="ul-event-info-title">{infoTitle}</span>
          <p className="ul-event-info-descr">{infoDescr}</p>
        </div>
        <Btn to={to} icon="fast-forward-double-right-arrows-symbol">
          {ctaLabel}
        </Btn>
      </div>
    </div>
  )
}
